import { AcademicOfferSections } from '../parts/Sections/AcademicOfferSections';
import { AcademicOfferSectionLoader } from '../parts/Sections/Loaders/CoursesSectionsLoader';

export function AcademicOfferSectionsStep() {
  return (
    <AcademicOfferSectionLoader>
      <AcademicOfferSections />
    </AcademicOfferSectionLoader>
  );
}
